import React, { CSSProperties } from "react";

import styles from "./CustomButton.module.scss";

interface CustomButtonProps {
  text: string;
  type: "button" | "submit";
  typeStyle: "fill" | "outline" | "text";
  functionOnClick?: () => void | Promise<void>;
  icon?: string;
  altIcon?: string;
  disabled?: boolean;
  style?: CSSProperties;
  showLoading?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  type,
  typeStyle,
  functionOnClick,
  icon,
  altIcon,
  disabled,
  style,
  showLoading,
}) => {
  return (
    <button
      style={style}
      type={type}
      className={`${styles.btn} ${styles[typeStyle]}`}
      onClick={functionOnClick}
      disabled={disabled || showLoading}
    >
      {showLoading ? (
        "Loading..."
      ) : (
        <>
          {icon && altIcon && <img src={icon} alt={altIcon} />}
          {text}
        </>
      )}
    </button>
  );
};

export default CustomButton;
